import React, {ReactNode} from "react";

import {CloseIcon} from "../icons/CloseIcon";

import "./MobileRightMenuHeader.css";

export interface MobileRightMenuHeaderProps {
    content?: ReactNode;
    onClose: (event: React.MouseEvent) => void;
}

export const MobileRightMenuHeader = ({content, onClose}: MobileRightMenuHeaderProps) => {
    return (
        <div className="MobileProfileHeader title-medium-bold">
            <CloseIcon
                className="MobileProfileHeader__icon"
                size={24}
                onClick={onClose}
            />
            {content}
        </div>
    );
};
